const setOverflowForContainer = ({
  container,
  placement,
  overflow
}) => {
  if (!container) {
    return;
  }
  if (placement === 'left' || placement === 'right') {
    container.style.overflowX = overflow;
    return;
  }
  container.style.overflowY = overflow;
};

export { setOverflowForContainer };
